const Loading = () => {
    return (
        <div className="flex items-center justify-center h-screen">
            <span className="loading loading-dots loading-lg items-center"></span>
        </div>
    );
};

export default Loading;
